<div class="funnel-checkout">
  <sb-spinner [isVisible]="shouldShowSpinner"></sb-spinner>
  <sb-modals></sb-modals>
  <main class="funnel-checkout__main"> <!-- OLD CODE [@routeAnimations]="getRouteAnimation(outlet)" > -->
    <router-outlet #outlet="outlet"></router-outlet>
  </main>
</div>
